import { defineMessages } from 'react-intl';
const DEFAULT_SOURCE_MESSAGES = defineMessages({
    webLabel: {
        id: 'be81449a76',
        defaultMessage: 'Web',
        description: 'Display name for the web search source option',
    },
    webDescription: {
        id: '2bee254dad',
        defaultMessage: 'Search across the entire Internet',
        description: 'Subtitle description for the web search source option',
    },
    academicLabel: {
        id: '50dd037dd0',
        defaultMessage: 'Academic',
        description: 'Display name for the academic papers search source option',
    },
    academicDescription: {
        id: 'db47be4d85',
        defaultMessage: 'Search academic papers',
        description: 'Subtitle description for the academic papers search source option',
    },
});
export const getDefaultApiSources = (intl) => {
    return [
        {
            id: 'web',
            display_name: intl.formatMessage(DEFAULT_SOURCE_MESSAGES.webLabel),
            description: intl.formatMessage(DEFAULT_SOURCE_MESSAGES.webDescription),
            auth_type: 'none',
            type: 'other',
            is_created_by_current_user: false,
            is_template: false,
            is_popular: false,
            is_user_selectable: true,
            is_consumer_only: false,
            is_premium: false,
            source_scope: 'global',
            auth_scope: 'individual',
            user_connections: [],
            capabilities: {},
            display_categories: [],
            source_details: { tagline: null, bullets: [] },
        },
        {
            id: 'scholar',
            display_name: intl.formatMessage(DEFAULT_SOURCE_MESSAGES.academicLabel),
            description: intl.formatMessage(DEFAULT_SOURCE_MESSAGES.academicDescription),
            auth_type: 'none',
            type: 'other',
            is_created_by_current_user: false,
            is_template: false,
            is_popular: false,
            is_user_selectable: true,
            is_consumer_only: false,
            is_premium: false,
            source_scope: 'global',
            auth_scope: 'individual',
            user_connections: [],
            capabilities: {},
            display_categories: [],
            source_details: { tagline: null, bullets: [] },
        },
    ];
};
//# sourceMappingURL=defaultSources.js.map